// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"05c6a6cc","175":"ddbb97e6","523":"5f0dcdc7","716":"879dd9cf","862":"3a7bedc9"}[chunkId] + ".css";
};